/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reportProfilePhotoNcmecInternal} from '../api'

export const useMutationReportProfilePhotoNcmecInternal = createReactQueryMutationHook('reportProfilePhotoNcmecInternal', reportProfilePhotoNcmecInternal)
